import script from "./ClipLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./ClipLoader.vue?vue&type=script&setup=true&lang=js"

import "./ClipLoader.vue?vue&type=style&index=0&id=637ea969&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-637ea969"]])

export default __exports__